import { __decorate } from "tslib";
import Vue from 'vue';
import { State } from 'vue-class-state';
import DocsModalComp from "./DocsModalComp";
export class DocsModal {
  constructor() {
    this.visible = false;
  }
  get comp() {
    return this.instance.$refs.comp;
  }
  init() {
    const h = this.$createElement;
    if (this.instance) {
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    this.instance = new Vue({
      render() {
        const h = arguments[0];
        return h(DocsModalComp, {
          "ref": "comp",
          "attrs": {
            "state": self
          }
        });
      }
    });
    const el = document.createElement('div');
    document.body.appendChild(el);
    this.instance.$mount(el);
  }
  show() {
    this.visible = true;
    this.init();
  }
  hide() {
    this.visible = false;
  }
  toggle() {
    this.init();
    this.visible = !this.visible;
  }
}
__decorate([State], DocsModal.prototype, "visible", void 0);
export const docsModal = new DocsModal();
//# sourceMappingURL=index.js.map
